<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>区域设置</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="0">
            <el-form :inline="true" :model="region" class="demo-form-inline" size="mini">
                <el-form-item label="区域名称" clearable>
                    <el-input v-model="region.condition.regionName" placeholder="区域名称" clearable=""></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="queryRegion">查询</el-button>
                    <el-button type="primary" @click="toAddRegion">新增</el-button>
                </el-form-item>
            </el-form>
            <el-table
            :data="regions"
            :height="tableHeight"
            size="mini"
            border
            @selection-change="handleSelectionChange"
            ref="tb"
            style="width: 100%">
                <el-table-column  type="selection" width="55"></el-table-column>
                <el-table-column fixed prop="regionName" label="区域名称"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="toUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10,20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog title="新增区域" :visible.sync="dialogFormVisible"  append-to-body>
            <el-form :inline="true" :model="addRegion" ref="addForm" size="mini">
                <div v-for="(item, index) in addRegion.regionList" :key="index">
                    <el-form-item label="区域名称" :prop="'regionList.'+index+'.regionName'" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                        <el-input v-model="item.regionName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="addItem()"> + </el-button>
                        <el-button @click="deleteItem(index)"> – </el-button>
                    </el-form-item>
                </div>
                <el-row type="flex" style="justify-content: right;">
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="submitRegion('addForm')">提交</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-dialog>
        <el-dialog title="修改酶切位点" :visible.sync="updateDialog"  append-to-body>
            <el-form :inline="true" :model="updateRegion" size="mini">
                <el-form-item label="区域名称" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                    <el-input v-model="updateRegion.regionName" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="submitRegionUpdate()" type="primary">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
    
</template>

<script>

    export default {
        name:'Region',
        data() {
            return {
                region: {
                    condition:{
                    },
                    pageNum: 1,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                regions: [],
                currentPage: 1,
                pageSize:20,
                total:10,
                timer:'',
                tableHeight: "",//表格高度
                tableHeight1: "",//表格高度
                tableHeight2: "",//表格高度
                dialogFormVisible: false,
                addRegion:{
                    regionList:[{regionName : ""}]  //接收每个input框的值
                },
                updateDialog: false,
                updateRegion: {},
                selectedRegion: {},
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryRegion();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryRegion();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryRegion();
                })
                .catch(() => {});
            },
            queryRegion() {
                this.region.pageNum = this.currentPage;
                this.region.pageSize = this.pageSize;
                this.$axios.post("/region/find",this.region).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.regions = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            getTableHeight() {
                let tableH = 300; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
                this.tableHeight1 = this.tableHeight/2;
                this.tableHeight2 = this.tableHeight/2 - 10;
            },
            toggleSelection(rows) {
                if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
                } else {
                this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(selection) {
                //this.multipleSelection = val;
                if (selection.length > 1) {
                    this.$refs.tb.clearSelection();
                    this.$refs.tb.toggleRowSelection(selection.pop());
                }else if (selection.length === 1) {
                    this.selectedRegion = selection.pop()
                } else {
                    this.selectedRegion = {}
                }
            },
            toAddRegion() {
                this.dialogFormVisible = true;
                while(this.addRegion.regionList.length > 0) {
                    this.addRegion.regionList.pop();
                }
                this.addRegion.regionList.push({
                    regionName: "",
                });
            },
            addItem() {
                this.addRegion.regionList.push({
                    regionName: "",
                });
            },
            deleteItem(i){
                if (this.addRegion.regionList.length <= 1) {
                    return false;
                }
                this.addRegion.regionList.splice(i, 1);
            },
            submitRegion(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/region/batchSave",this.addRegion.regionList).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message.info(res.data.message);
                                this.dialogFormVisible = false;
                                this.queryRegion();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                } else {
                    return false;
                }
                });
            },
            submitRegionUpdate() {
                this.$axios.post("/region/update",this.updateRegion).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message.info(res.data.message);
                            this.updateDialog = false;
                            this.queryRegion();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            toUpdate(row) {
                this.updateRegion = row;
                this.updateDialog = true;
            },
            del(row) {
                this.$confirm('您确认删除此数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post("/region/delete",row).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.queryRegion();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }
        },
        mounted() {
            this.queryRegion();
        },
        created() {
            this.getTableHeight();
        }
        
    }


</script>

<style scoped>

   .el-row {
       margin-top: 30px;
       text-align: left;
       padding-left: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

</style>
